<template>
  <a-result title="您当前未配置云账号">
    <template #subTitle>
      {{ '点击页面右下角'}}<a-icon type="control" />{{ "快捷图标，可再次打开配置向导查看状态或者进行下一步配置"}}
    </template>
    <template #extra>
      <a-button type="primary" @click="createCloudAccount" :loading="loading">
        {{ loading ? '正在跳转' : '添加账号'}}
      </a-button>
    </template>
  </a-result>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CloudAccountSetupEmptyPage',
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters('app', ['user_guide']),
  },
  methods: {
    async createCloudAccount () {
      this.loading = true
      // payload.current_step_tips = '如果您已配置云账号,点击此处继续'
      this.$router.push('/cloudaccount/create').then(() => {
        window.location.reload()
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>

</style>
